import { makeStyles, Theme } from '@material-ui/core'

import { AlertDialogProps } from './AlertDialogProps'

export const useAlertDialogStyles = makeStyles<
  Theme,
  AlertDialogProps,
  'cancelButton' | 'cancelIcon' | 'card' | 'cardActions' | 'icon' | 'root'
>((theme) => ({
  cancelButton: {
    color: theme.palette.grey[700],
  },
  cancelIcon: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(2),
  },
  card: {
    borderRadius: theme.spacing(0.75),
    borderTop: (props) => `${theme.spacing(1.25)}px solid ${theme.palette[props.severity || 'info'].main}`,
  },
  cardActions: {
    background: theme.palette.grey[100],
    justifyContent: 'flex-end',
  },
  icon: {
    fontSize: theme.spacing(5),
  },
  root: {
    borderRadius: theme.spacing(0.75),
  },
}))
